module.exports = __webpack_public_path__ + "img/wenjianda.3294d8aa.png";